// frontend/src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer style={{
            background: 'var(--primary)',
            color: 'rgba(255,255,255,0.85)',
            padding: '2rem 2rem 1rem',
            fontSize: '0.85rem',
        }}>
            <div style={{
                maxWidth: '1100px',
                margin: '0 auto',
            }}>
                {/* Sección superior */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                    gap: '1.5rem',
                    marginBottom: '1.5rem',
                }}>
                    {/* Columna 1 */}
                    <div>
                        <h4 style={{
                            color: '#fff',
                            fontSize: '1rem',
                            fontWeight: 700,
                            marginBottom: '0.75rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                        }}>
                             Estudio Jurídico Previsional - GestiónEJP
                        </h4>
                        <p style={{ lineHeight: 1.7, margin: 0, fontSize: '0.8rem' }}>
                            Sistema interno de gestión de trámites previsionales.
                        </p>
                    </div>

                    {/* Columna 2: Contacto */}
                    <div>
                        <h4 style={{ color: '#fff', fontSize: '1rem', fontWeight: 700, marginBottom: '0.75rem' }}>
                             Contacto
                        </h4>
                        <div style={{ lineHeight: 2, fontSize: '0.8rem' }}>
                            <div><i className="bi bi-geo-alt me-2"></i>Córdoba, Argentina</div>
                            <div><i className="bi bi-envelope me-2"></i>contacto.gestionejp@gmail.com</div>
                        </div>
                    </div>

                    {/* Columna 3: Legal */}
                    <div>
                        <h4 style={{ color: '#fff', fontSize: '1rem', fontWeight: 700, marginBottom: '0.75rem' }}>
                             Legal
                        </h4>
                        <div style={{ lineHeight: 2, fontSize: '0.8rem' }}>
                            <div>
                                <Link to="/politica-privacidad" style={{
                                    color: 'rgba(255,255,255,0.85)',
                                    textDecoration: 'none',
                                    transition: 'color 0.2s',
                                }}
                                    onMouseEnter={(e) => e.target.style.color = '#fff'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.85)'}
                                >
                                    <i className="bi bi-shield-check me-2"></i>
                                    Política de Privacidad
                                </Link>
                            </div>
                            <div>
                                <Link to="/terminos" style={{
                                    color: 'rgba(255,255,255,0.85)',
                                    textDecoration: 'none',
                                    transition: 'color 0.2s',
                                }}
                                    onMouseEnter={(e) => e.target.style.color = '#fff'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.85)'}
                                >
                                    <i className="bi bi-file-earmark-text me-2"></i>
                                    Términos de Uso
                                </Link>
                            </div>
                            <div style={{ marginTop: '0.25rem', fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)' }}>
                                <i className="bi bi-lock me-2"></i>
                                Acceso exclusivo para personal autorizado
                            </div>
                        </div>
                    </div>
                </div>

                {/* Separador */}
                <div style={{
                    borderTop: '1px solid rgba(255,255,255,0.2)',
                    paddingTop: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '0.5rem',
                    fontSize: '0.8rem',
                }}>
                    <p style={{ margin: 0 }}>
                        © {currentYear} GestiónEJP - Todos los derechos reservados.
                    </p>
                    <p style={{ margin: 0, fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)' }}>
                        🔒 Plataforma segura con cifrado SSL
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

